import { Get } from '../http/httpVerbs';

export const apiGetPostThemes = async () => {
    try {
        const response = await Get(`${process.env.REACT_APP_API_URL}/posts/themes`);
        
        return response;
    } catch (error) {
        console.error('API apiGetPostThemes ERROR:', error);
        throw error;
    }
};
